package empiresmp.components.fade.animation

import kotlinx.coroutines.currentCoroutineContext
import kotlinx.coroutines.delay
import kotlinx.coroutines.isActive
import kotlin.time.Duration

class InterpolateAnimator(private val duration: Duration) : Animator {
    override suspend fun animate(
        startValue: Float,
        endValue: Float,
        onUpdate: (Float) -> Unit
    ) {
        val frameTime = 16L // ~60fps
        var elapsed = 0L

        while (currentCoroutineContext().isActive && elapsed < duration.inWholeMilliseconds) {
            val fraction = elapsed.toFloat() / duration.inWholeMilliseconds
            val interpolated = startValue + fraction * (endValue - startValue)
            onUpdate(interpolated)

            delay(frameTime)
            elapsed += frameTime
        }
        // Ensure final value is set exactly to endValue
        onUpdate(endValue)
    }
}
